import React from "react";
import { FiLoader } from "react-icons/fi";
import { formatTableCellValue } from "../utils";

const ClassificationTable = ({
  selectedCategory,
  classificationLoading,
  classificationError,
  classificationData,
  classificationMonths,
  segmentColumns,
  transformedClassificationData,
}) => {
  if (!selectedCategory) return null;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="border-b border-slate-200 p-4">
        <h2 className="text-lg font-semibold text-slate-800">
          Cost Classification for: {selectedCategory}
        </h2>
      </div>

      {classificationLoading && (
        <div className="flex items-center justify-center gap-2 p-8 text-sm text-slate-500">
          <FiLoader className="h-5 w-5 animate-spin" />
          <span>Loading classification details...</span>
        </div>
      )}

      {classificationError && (
        <div className="m-4 rounded-lg border border-red-200 bg-red-100 p-3 text-sm text-red-600">
          {classificationError}
        </div>
      )}

      {!classificationLoading && !classificationError && (
        <div className="overflow-x-auto">
          {classificationData.length > 0 ? (
            <table className="min-w-full table-fixed border-collapse text-sm text-slate-700">
              <thead className="bg-slate-50">
                <tr>
                  <th rowSpan={2} className="w-16 text-center px-4 py-3">
                    #
                  </th>
                  <th rowSpan={2} className="w-80 px-4 py-3 text-left">
                    Particulars
                  </th>

                  {classificationMonths.map((month) => (
                    <th
                      key={month}
                      colSpan={segmentColumns.length}
                      className="text-center font-bold text-blue-600"
                    >
                      {month}
                    </th>
                  ))}
                </tr>

                <tr>
                  {classificationMonths.flatMap((month) =>
                    segmentColumns.map((col) => (
                      <th
                        key={`${month}-${col}`}
                        className="text-center font-semibold"
                      >
                        {col}
                      </th>
                    ))
                  )}
                </tr>
              </thead>

              <tbody>
                {transformedClassificationData.map((row, index) => {
                  const isTotal = row.Particulars.toLowerCase() === "total";

                  return (
                    <tr
                      key={index}
                      className={isTotal ? "bg-slate-50 font-bold" : "border-t"}
                    >
                      <td className="px-4 py-3">{isTotal ? "" : index + 1}</td>
                      <td className="px-4 py-3">{row.Particulars}</td>

                      {classificationMonths.map((month) =>
                        segmentColumns.map((col) => {
                          const value = row[`${month}_${col}`];

                          return (
                            <td
                              key={`${month}-${col}`}
                              className={`px-4 py-3 text-center font-mono ${
                                value > 0
                                  ? "text-green-600"
                                  : value < 0
                                  ? "text-red-600"
                                  : "text-slate-400"
                              }`}
                            >
                              {formatTableCellValue(value)}
                            </td>
                          );
                        })
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="py-8 text-center text-sm text-slate-400">
              No classification data available for {selectedCategory}.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClassificationTable;
